import { connect } from 'react-redux';
import { onPing } from 'modules/conference/actions/connectionMeter';

import ConnectionMeter from './ConnectionMeter';


export default connect(
  () => ({}),
  { onPing },
)(ConnectionMeter);
